import EntityFieldCard from './EntityFieldCard';

export default EntityFieldCard;
